(() => {
  const root = document.querySelector('.de-shop-all');
  if (!root) return;

  const tabs = [...root.querySelectorAll('.de-shop-tabs a')];
  const sections = [...root.querySelectorAll('.de-shop-series')];
  const tabBar = root.querySelector('.de-shop-tabs');
  const stickyFilters = root.querySelector('.de-shop-sticky-filters');
  const backdrop = root.querySelector('.de-shop-sticky-backdrop');
  // Give both bars and their opaque backing the same viewport stacking context.
  document.body.append(backdrop, tabBar, stickyFilters);
  let tabUpdateQueued = false;
  let pendingNavigation = null;
  let navigationFrame = 0;
  function markActive(id) {
    for (const tab of tabs) {
      if (tab.hash === '#' + id) tab.setAttribute('aria-current', 'location');
      else tab.removeAttribute('aria-current');
    }
  }
  function updateActiveTab() {
    const filtersBottom = root.querySelector('.de-shop-filters').getBoundingClientRect().bottom;
    const filtered = root.classList.contains('is-filtered');
    const headerBottom = document.querySelector('.de-site-header')?.getBoundingClientRect().bottom || (innerWidth < 768 ? 76 : 90);
    const revealLine = headerBottom + 10;
    document.documentElement.style.setProperty('--de-shop-sticky-top', Math.round(revealLine) + 'px');
    document.documentElement.style.setProperty('--de-shop-panel-bottom', Math.ceil(revealLine + (filtered ? stickyFilters : tabBar).offsetHeight + 16) + 'px');
    const reveal = filtersBottom < revealLine && root.getBoundingClientRect().bottom > revealLine + 40;
    stickyFilters.classList.toggle('is-visible', filtered && reveal);
    backdrop.classList.toggle('is-visible', reveal);
    document.body.classList.toggle('de-shop-has-sticky', reveal);
    tabBar.classList.toggle('is-visible', !filtered && reveal);
    if (filtered) return;
    const threshold = tabBar.getBoundingClientRect().bottom + Math.min(104, Math.max(65, innerHeight * .12));
    let active = sections[0];
    let activeTop = -Infinity;
    for (const section of sections) {
      const top = section.getBoundingClientRect().top;
      if (top > threshold) continue;
      // Vibe and Nite share a row on desktop, so keep the chosen series on a tie.
      if (top > activeTop || (top === activeTop && location.hash === '#' + section.id)) {
        active = section;
        activeTop = top;
      }
    }
    if (pendingNavigation) {
      const target = sections.find(section => section.id === pendingNavigation.id);
      if (performance.now() < pendingNavigation.until && target && target.getBoundingClientRect().top > threshold + 8) active = target;
      else pendingNavigation = null;
    }
    markActive(active.id);
  }
  document.addEventListener('click', event => {
    const anchor = event.target.closest('a[href^="#de-shop-"]');
    if (!anchor || !sections.some(section => '#' + section.id === anchor.hash)) return;
    event.preventDefault();
    const target = sections.find(section => '#' + section.id === anchor.hash);
    if (navigationFrame) cancelAnimationFrame(navigationFrame);
    pendingNavigation = { id: target.id, until: performance.now() + 1050 };
    markActive(target.id);
    if (location.hash !== anchor.hash || new URL(location.href).searchParams.has('feature')) {
      const url = new URL(location.href);
      url.searchParams.delete('feature');
      url.hash = anchor.hash;
      history.pushState(null, '', url);
    }
    // The overview may first remove a product filter; measure after that layout updates.
    requestAnimationFrame(() => {
      const from = window.scrollY;
      const headerBottom = document.querySelector('.de-site-header')?.getBoundingClientRect().bottom || (innerWidth < 768 ? 76 : 90);
      const destination = Math.max(0, from + target.getBoundingClientRect().top - headerBottom - tabBar.offsetHeight - 26);
      if (matchMedia('(prefers-reduced-motion: reduce)').matches || Math.abs(destination - from) < 3) {
        window.scrollTo(0, destination);
        pendingNavigation = null;
        updateActiveTab();
        return;
      }
      const duration = Math.min(650, Math.max(390, Math.abs(destination - from) * .18));
      const start = performance.now();
      const tick = now => {
        const progress = Math.min(1, (now - start) / duration);
        const eased = 1 - Math.pow(1 - progress, 3);
        window.scrollTo(0, from + (destination - from) * eased);
        if (progress < 1) navigationFrame = requestAnimationFrame(tick);
        else { navigationFrame = 0; pendingNavigation = null; updateActiveTab(); }
      };
      navigationFrame = requestAnimationFrame(tick);
    });
  });
  ['wheel', 'touchstart'].forEach(type => addEventListener(type, () => {
    if (!navigationFrame) return;
    cancelAnimationFrame(navigationFrame);
    navigationFrame = 0;
    pendingNavigation = null;
    updateActiveTab();
  }, { passive: true }));
  addEventListener('hashchange', () => {
    const target = sections.find(section => '#' + section.id === location.hash);
    if (target) { pendingNavigation = { id: target.id, until: performance.now() + 1800 }; markActive(target.id); }
    requestAnimationFrame(updateActiveTab);
  });
  addEventListener('load', updateActiveTab, { once: true });
  addEventListener('scroll', () => {
    if (tabUpdateQueued) return;
    tabUpdateQueued = true;
    requestAnimationFrame(() => { tabUpdateQueued = false; updateActiveTab(); });
  }, { passive: true });
  addEventListener('resize', updateActiveTab);

  const cards = [...root.querySelectorAll('.de-shop-product')];
  const positions = new Map(cards.map(card => {
    const marker = document.createComment('Original position for ' + card.dataset.product);
    card.before(marker);
    return [card, marker];
  }));
  const filterResults = root.querySelector('.de-shop-filter-results');
  const filterGrid = filterResults.querySelector('.de-shop-filter-grid');
  const catalog = root.querySelector('.de-shop-catalog');
  const filterLabels = { all: 'All products', battery: 'Rechargeable', app: 'App control' };
  let activeFilter = 'all';
  function setFilter(key, { scroll = true, updateUrl = true } = {}) {
    if (!filterLabels[key]) key = 'all';
    activeFilter = key;
    for (const card of cards) positions.get(card).after(card);
    const filtered = key !== 'all';
    root.classList.toggle('is-filtered', filtered);
    catalog.hidden = filtered;
    filterResults.hidden = !filtered;
    if (filtered) {
      const matching = cards.filter(card => card.dataset.features.split(/\s+/).includes(key));
      filterGrid.append(...matching);
      filterResults.querySelector('h2').textContent = filterLabels[key] + ' · ' + matching.length + ' products';
    }
    document.querySelectorAll('.de-shop-filter').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === key)));
    if (updateUrl) {
      const url = new URL(location.href);
      if (filtered) url.searchParams.set('feature', key);
      else url.searchParams.delete('feature');
      history.pushState(null, '', url);
    }
    if (scroll) requestAnimationFrame(() => (filtered ? filterResults : root.querySelector('.de-shop-filters')).scrollIntoView({ behavior: 'smooth', block: 'start' }));
    requestAnimationFrame(updateActiveTab);
  }
  document.querySelectorAll('.de-shop-filter').forEach(button => button.addEventListener('click', () => setFilter(button.dataset.filter)));
  root.querySelector('.de-shop-filter-clear').addEventListener('click', () => setFilter('all'));
  root.addEventListener('click', event => {
    if (activeFilter !== 'all' && event.target.closest('.de-shop-overview-item')) setFilter('all', { scroll: false, updateUrl: false });
  }, true);
  addEventListener('popstate', () => setFilter(new URL(location.href).searchParams.get('feature') || 'all', { scroll: false, updateUrl: false }));
  const initialFilter = new URL(location.href).searchParams.get('feature');
  if (initialFilter in filterLabels) setFilter(initialFilter, { scroll: false, updateUrl: false });
  const initialSection = sections.find(section => '#' + section.id === location.hash);
  if (initialSection) { pendingNavigation = { id: initialSection.id, until: performance.now() + 1800 }; markActive(initialSection.id); }
  requestAnimationFrame(updateActiveTab);

  const featureDescriptions = { battery: 'Built-in rechargeable battery for listening without a power cable.', app: 'Control sound, light and routines in the app. Requires 2.4 GHz Wi-Fi.' };
  root.querySelectorAll('.de-shop-feature').forEach(button => button.addEventListener('click', () => {
    const cardCopy = button.closest('.de-shop-product-copy');
    const old = cardCopy.querySelector('.de-shop-feature-note');
    if (old) { old.remove(); return; }
    root.querySelectorAll('.de-shop-feature-note').forEach(note => note.remove());
    const note = document.createElement('span');
    note.className = 'de-shop-feature-note';
    note.setAttribute('role', 'status');
    note.textContent = featureDescriptions[button.dataset.feature];
    cardCopy.querySelector(':scope > p').after(note);
  }));
  root.addEventListener('click', event => {
    if (!event.target.closest('.de-shop-feature')) root.querySelectorAll('.de-shop-feature-note').forEach(note => note.remove());
  });
  root.addEventListener('keydown', event => {
    if (event.key === 'Escape') root.querySelectorAll('.de-shop-feature-note').forEach(note => note.remove());
  });

  const comparisons = {"sunrise1":{"choice":"A straightforward sunrise alarm","light":"Gradual sunrise light + 9 night-light colors","wake":"Adjustable sunrise duration; natural alarm sounds","sounds":"29 sleep sounds","controls":"App-free"},"dreamegg-sunrise-1-plus":{"choice":"Personalized bedtime and wake-up routines","light":"Sunrise and sunset simulation; adjustable white and color light","wake":"Up to 6 personalized alarms","sounds":"34 sleep sounds","controls":"App control (2.4 GHz Wi-Fi only)"},"sunrise-2-ultra-sunrise-sleep-wake-clock":{"choice":"A wider sunrise glow","light":"Wide-angle sunrise light + 10 ambient colors","wake":"One-tap snooze from the dial","sounds":"29 sleep sounds","controls":"App-free"},"sunrise-beam":{"choice":"A compact, upright bedside light","light":"Warm yellow sunrise light and white light only","wake":"Upward sunrise light; adjustable from 0–60 min","sounds":"29 sleep sounds","controls":"App-free"},"classic-d1plus":{"alarm":"6 wake-up sounds; 9-min snooze","light":"Clock and warm night light dim independently","sounds":"29 sleep sounds","controls":"App-free"},"classic-d1-nova-sound-machine":{"alarm":"7 wake-up sounds","light":"Night light; 5 clock display brightness levels","sounds":"25 sleep sounds","controls":"App-free"},"classic-d1":{"alarm":"No alarm clock","light":"Built-in night light","sounds":"24 sleep sounds","controls":"App-free"},"sleep-lite-d11":{"carry":"Clip for a stroller or bag","power":"Rechargeable via USB-C","detail":"Adjustable night light","sounds":"21 sleep sounds","controls":"App-free"},"lite-d11-max":{"carry":"Carry lanyard for a stroller or bag","power":"1,800 mAh rechargeable battery","detail":"Child lock and last-setting memory","sounds":"21 sleep sounds","controls":"App-free"},"pocket-sleep-1":{"carry":"50 g; fits in a pocket","power":"1,000 mAh battery; USB-C charging","detail":"32 volume levels","sounds":"16 sleep sounds","controls":"App-free"},"lite-cozy":{"carry":"70 g; quick-release strap","power":"USB-C; up to 20 hours per charge, depending on settings","detail":"Volume roller","sounds":"19 sleep sounds","controls":"App-free"}};
  const dialog = root.querySelector('.de-shop-dialog');
  const content = root.querySelector('.de-shop-compare-content');
  const close = root.querySelector('.de-shop-dialog-close');
  const compareFields = {
    sunrise: {choice:'Best for',light:'Light options',controls:'Controls',wake:'Wake-up features',sounds:'Sleep sounds'},
    classic: {alarm:'Alarm',light:'Night light & display',sounds:'Sleep sounds',controls:'Controls'},
    lite: {carry:'Size & carrying',power:'Battery & charging',detail:'Standout feature',sounds:'Sleep sounds',controls:'Controls'}
  };
  const narrowComparison = matchMedia('(max-width:767px)');
  let comparedModels = [];
  let comparedSeries = '';
  let comparisonPair = [0, 1];
  function makeElement(tag, className, textValue) {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (textValue !== undefined) element.textContent = textValue;
    return element;
  }
  function makeArrow() {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '1.5');
    svg.setAttribute('aria-hidden', 'true');
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', 'M4 12h15m-6-6 6 6-6 6');
    svg.append(path);
    return svg;
  }
  function modelHeader(model, slot = -1) {
    const column = makeElement('div', 'de-shop-compare-model');
    if (slot >= 0) {
      const label = makeElement('label', 'de-shop-compare-select-label', slot === 0 ? 'First model' : 'Second model');
      const select = makeElement('select', 'de-shop-compare-select');
      select.setAttribute('aria-label', label.textContent);
      comparedModels.forEach((candidate, index) => {
        const option = new Option(candidate.name, String(index));
        option.selected = comparedModels.indexOf(model) === index;
        option.disabled = comparisonPair[1 - slot] === index;
        select.add(option);
      });
      select.addEventListener('change', () => {
        comparisonPair[slot] = Number(select.value);
        renderComparison();
      });
      column.append(label, select);
    }
    const imageLink = makeElement('a', 'de-shop-compare-image-link');
    imageLink.href = model.link;
    imageLink.setAttribute('aria-label', 'View ' + model.name);
    const image = model.image.cloneNode();
    image.className = 'de-shop-compare-image';
    if (model.handle === 'sunrise-2-ultra-sunrise-sleep-wake-clock') image.classList.add('is-sunrise-two');
    image.loading = 'lazy';
    imageLink.append(image);
    const name = slot >= 0 ? makeElement('span', 'de-shop-compare-mobile-name', model.name) : makeElement('h3', '', model.name);
    const price = model.price.cloneNode(true);
    price.classList.add('de-shop-compare-price');
    const link = makeElement('a', 'de-shop-compare-more', 'Learn more');
    link.href = model.link;
    link.append(makeArrow());
    column.append(imageLink, name, price, link);
    return column;
  }
  function renderComparison() {
    const fields = Object.entries(compareFields[comparedSeries] || {});
    content.classList.toggle('is-mobile-pair', narrowComparison.matches);
    if (narrowComparison.matches) {
      const pair = comparisonPair.map(index => comparedModels[index]);
      const headings = makeElement('div', 'de-shop-compare-pair-heading');
      pair.forEach((model, index) => headings.append(modelHeader(model, index)));
      const rows = makeElement('div', 'de-shop-compare-pair-rows');
      fields.forEach(([key, label]) => {
        const row = makeElement('section', 'de-shop-compare-pair-row');
        const title = makeElement('h3', '', label);
        const values = makeElement('div', 'de-shop-compare-pair-values');
        pair.forEach(model => values.append(makeElement('p', '', model.details[key] || '—')));
        row.append(title, values);
        rows.append(row);
      });
      content.replaceChildren(headings, rows);
      return;
    }
    const table = makeElement('table', 'de-shop-compare-table');
    table.style.minWidth = (145 + comparedModels.length * 190) + 'px';
    const caption = makeElement('caption', 'de-shop-visually-hidden', root.querySelector('#de-shop-compare-title').textContent);
    const thead = document.createElement('thead');
    const headingRow = document.createElement('tr');
    const first = document.createElement('th');
    first.scope = 'col';
    headingRow.append(first);
    comparedModels.forEach(model => {
      const cell = document.createElement('th');
      cell.scope = 'col';
      cell.append(modelHeader(model));
      headingRow.append(cell);
    });
    thead.append(headingRow);
    const tbody = document.createElement('tbody');
    fields.forEach(([key, label]) => {
      const row = document.createElement('tr');
      const heading = makeElement('th', '', label);
      heading.scope = 'row';
      row.append(heading);
      comparedModels.forEach(model => row.append(makeElement('td', '', model.details[key] || '—')));
      tbody.append(row);
    });
    table.append(caption, thead, tbody);
    content.replaceChildren(table);
  }
  close.addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {
    if (event.target === dialog) dialog.close();
  });
  narrowComparison.addEventListener('change', () => { if (dialog.open) renderComparison(); });
  root.querySelectorAll('.de-shop-compare-series').forEach(button => {
    button.addEventListener('click', () => {
      comparedSeries = button.dataset.series;
      comparedModels = cards.filter(card => card.dataset.series === comparedSeries).map(card => {
        let details = comparisons[card.dataset.product] || {};
        try { if (card.dataset.comparison) details = {...details, ...JSON.parse(card.dataset.comparison)}; } catch (_) { /* Use the known model details. */ }
        const productLink = card.querySelector('.de-shop-product-name');
        return {name:productLink.textContent,handle:card.dataset.product,link:productLink.href,image:card.querySelector('.de-shop-product-media img'),price:card.querySelector('.de-shop-price'),details};
      });
      if (comparedModels.length < 2) return;
      comparisonPair = [0, 1];
      root.querySelector('#de-shop-compare-title').textContent = 'Compare ' + comparedSeries[0].toUpperCase() + comparedSeries.slice(1) + ' models';
      renderComparison();
      dialog.showModal();
      root.querySelector('#de-shop-compare-title').focus({ preventScroll: true });
    });
  });
})();
